// src/components/CompletedProjects.js
"use client";
import React, { useRef, useEffect, useState } from "react";
import { useScroll, useTransform, motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "../styles/CompletedProjects.css";
import "./../styles/Elecinstallation.css";

import Beams from "./Beams";
import completedImage from "../assets/ongoing.avif";

import '@fortawesome/fontawesome-free/css/all.min.css';


const ElecDesignHeroSection = ({ data }) => {
  const timelineRef = useRef(null);
  const containerRef = useRef(null);
  const [timelineHeight, setTimelineHeight] = useState(0);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const calculateAndUpdateTimelineHeight = () => {
      if (timelineRef.current) {
        const newHeight = timelineRef.current.getBoundingClientRect().height;
        setTimelineHeight(prevHeight => {
          if (newHeight > 0 && (newHeight !== prevHeight || prevHeight === 0)) {
            return newHeight;
          }
          return prevHeight;
        });
      }
    };

    const handleLayoutReady = () => {
      calculateAndUpdateTimelineHeight();
      AOS.refresh();
    };

    const initialCalcTimer = setTimeout(calculateAndUpdateTimelineHeight, 50);

    if (document.readyState === "complete") {
      const readyTimer = setTimeout(handleLayoutReady, 100);
      return () => clearTimeout(readyTimer);
    } else {
      window.addEventListener("load", handleLayoutReady);
    }

    window.addEventListener("resize", handleLayoutReady);

    return () => {
      clearTimeout(initialCalcTimer);
      window.removeEventListener("load", handleLayoutReady);
      window.removeEventListener("resize", handleLayoutReady);
    };
  }, [data]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(
    scrollYProgress,
    [0, 1],
    [0, timelineHeight]
  );
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div className="elec-design-hero-container" ref={containerRef}>
      <div className="elec-design-hero-header">
        {/* <h2 className="elec-design-hero-title">Completed Projects</h2> */}
        <p className="elec-design-hero-description">
          These projects highlight our commitment to quality, safety, and innovation, executed with precision and client satisfaction.
        </p>
      </div>

      <div ref={timelineRef} className="elec-design-hero-timeline">
        {data.map((item, index) => (
          <div key={index} className="elec-design-hero-step">
            <div className="elec-design-hero-sticky">
              <div className="elec-design-hero-marker-outer">
                <div className="elec-design-hero-marker-inner" />
              </div>
              <h3 className="elec-design-hero-step-title-desktop">{item.title}</h3>
            </div>

            <div className="elec-design-hero-step-content cn-1">
              <h3 className="elec-design-hero-step-title-mobile">{item.title}</h3>
              <div className="elec-design-hero-step-paragraph" data-aos="fade-left">
                {item.paragraph.points.map((point, idx) => (
                  <p key={idx} className="elec-design-hero-step-point">
  <span className="elec-design-hero-arrow-icon-1">
<i className="star1">★</i>
</span>
 {point}
</p>
                ))}
              </div>
            </div>
          </div>
        ))}

        <div
          style={{ height: `${timelineHeight}px` }}
          className="elec-design-hero-progress-bar-wrapper"
        >
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="elec-design-hero-progress-bar"
          />
        </div>
      </div>
    </div>
  );
};

const OngoingProject= () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const timelineData = [
   {
  title: "Ongoing Projects",

 paragraph: {
  points: [
      "Upgradation of Electrical System - WARSAN STP",
    "Operation & Maintenance Service at 132/11kV MOLJWRSN SS ",
    "Remote End Modification works at Various DEWA SS pertaining to the Demolition of HAMR, CMC, INDS, SATW, JABL SS from DEWA network",
    "Remote End Modification works at Various DEWA SS pertaining to Cable modifications",
    "Installation Testing & Commissioning works at 132/11kV MUROOJ SS",
    "Installation Testing & Commissioning works at 132/11kV HARTLAND SS ",
      "Installation Testing & Commissioning works at 132/11kV FREJBRSH SS",
      "Testing & Commissioning works at 132/11kV MDNAHIND SS",
      "Testing & Commissioning works at 132/11kV MEASEIM SS",
      "Dismantling of GIS bay in E-station",
      "Installation of lighting and small power work at 132/11kV MUROOJ SS ",
      "Minor Service Agreement - Transformers Maintenance Services (Yearly)",
      "SERVICES OF MANPOWER FOR BRIDGE 5&6 INSTALLATION WORKS AT JEBEL ALI DREP SUBSTATION",
      "Busbar modification work at  DPE Margham Plant",
      "Serivces of Consultant Engineer - 11kV SWGR Engineer",
      "Serivces of Consultant Engineer - GIS Engineer",
      "Services Of Engineers & Technicians ",
  ]
}

},
  ];

  return (
    <>
        <div className="completed-container">
        {/* Beam background */}
        <div className="completed-beam-background">
          <Beams
            beamWidth={1.4}
            beamHeight={30}
            beamNumber={14}
            lightColor="#00CCFF"
            speed={20}
            noiseIntensity={0}
            scale={0.19}
            rotation={59}
          />
        </div>

        {/* Left content section */}
        <div className="completed-left" data-aos="fade-right">
          <h1>Ongoing Projects</h1>
          <p>
            Acume realises that each project we undertake is unique in terms of our clients management values.
            Our framework is key to providing services that enrich their existing systems and processes at their facility.
            Our approach is to build strong business partnerships with our clientele that emphasize our prime interest:
            <strong> "Client Focused Customization"</strong>.
          </p>
        </div>

        {/* Right image section */}
        <div className="completed-right" data-aos="fade-left">
          <img src={completedImage} alt="Completed Projects" className="completed-image" />
        </div>
      </div>

      <ElecDesignHeroSection data={timelineData} />
    </>
  );
};

export default OngoingProject;
